import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  generateMoreError: null,
  isConnecting: false,
  isStreaming: false,
  issueEnd: null,
  issueId: null,
  issueStart: null,
  issueText: null,
  paragraphId: null,
  rephraseType: null,
  sourceText: null,
  streamingText: "",
  suggestions: [],
};

export const rephraseSlice = createSlice({
  name: "rephrase",
  initialState: INITIAL_STATE,
  reducers: {
    initializeForStreaming: (state, { payload = {} }) => {
      state.isStreaming = false;
      state.issueEnd = payload.issueEnd ?? null;
      state.issueId = payload.issueId || null;
      state.issueStart = payload.issueStart ?? null;
      state.issueText = payload.issueText ?? null;
      state.paragraphId = payload.paragraphId || null;
      state.rephraseType = payload.rephraseType || null;
      state.sourceText = payload.sourceText || null;
      state.suggestions = [];
    },
    resetRephrase: () => INITIAL_STATE,
    setIsConnecting: (state, { payload }) => {
      state.isConnecting = Boolean(payload);
    },
    setGenerateMoreError: (state, { payload }) => {
      state.generateMoreError = payload ?? null;
    },
    setIsStreaming: (state, { payload }) => {
      state.isStreaming = Boolean(payload);
    },
    setRephraseType: (state, { payload }) => {
      state.rephraseType = payload ?? null;
    },
    setSuggestions: (state, { payload }) => {
      state.suggestions = payload;
    },
    setStreamingText: (state, { payload }) => {
      state.streamingText = payload ?? "";
    },
  },
});

export const {
  initializeForStreaming,
  resetRephrase,
  setGenerateMoreError,
  setIsConnecting,
  setIsStreaming,
  setRephraseType,
  setSuggestions,
  setStreamingText,
} = rephraseSlice.actions;

export default rephraseSlice.reducer;
